import React from "react";

const Offers = props => {
  return <h1>Welcome to offers!</h1>
}

export default Offers;